"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleApp = void 0;
var Config_1 = require("../../app/Config");
var FaceTecSDK_1 = require("./../../core-sdk/FaceTecSDK.js/FaceTecSDK");
var LivenessCheckProcessor_1 = require("./processors/LivenessCheckProcessor");
var EnrollmentProcessor_1 = require("./processors/EnrollmentProcessor");
var AuthenticateProcessor_1 = require("./processors/AuthenticateProcessor");
var SampleAppUtilities_1 = require("./utilities/SampleAppUtilities");
var PhotoIDMatchProcessor_1 = require("./processors/PhotoIDMatchProcessor");
var PhotoIDScanProcessor_1 = require("./processors/PhotoIDScanProcessor");
var ThemeHelpers_1 = require("./utilities/ThemeHelpers");
var AdditionalScreens_1 = require("./utilities/AdditionalScreens");
var DeveloperStatusMessages_1 = require("./utilities/DeveloperStatusMessages");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var _devMode = process.env.NODE_ENV === "development";
exports.SampleApp = (function () {
    var latestEnrollmentIdentifier = "";
    var latestProcessor;
    var latestSessionResult = null;
    var latestIDScanResult = null;
    // Wait for onload to be complete before attempting to access the Browser SDK.
    window.onload = function () {
        SampleAppUtilities_1.SampleAppUtilities.formatUIForDevice();
        // Set a the directory path for other FaceTec Browser SDK Resources.
        //  FaceTecSDK.setResourceDirectory("./../../core-sdk/FaceTecSDK.js/resources");
        FaceTecSDK_1.FaceTecSDK.setResourceDirectory("facetec/resources");
        // Set the directory path for required FaceTec Browser SDK images.
        //FaceTecSDK.setImagesDirectory("./../../core-sdk/FaceTec_images");
        FaceTecSDK_1.FaceTecSDK.setImagesDirectory("facetec/images");
        console.log("FaceTecApp -> window.onload");
        console.log("FaceTecApp -> window.onload -> Config.didSucceed", Config_1.Config.didSucceed);
        console.log("FaceTecApp -> window.onload -> Config", Config_1.Config.ProductionKeyText, "and", Config_1.Config.DeviceKeyIdentifier);
        /**@TODO @Desmond Fix context switch error when the weeb-app tries to redirect automatically */
        SampleAppUtilities_1.SampleAppUtilities.fadeInMainUIContainer();
    };
    // Clear previous session results;
    function initializeResultObjects() {
        latestSessionResult = null;
        latestIDScanResult = null;
    }
    // Initiate a 3D Liveness Check.
    function onLivenessCheckPressed() {
        initializeResultObjects();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get a Session Token from the FaceTec SDK, then start the 3D Liveness Check.
        getSessionToken(function (sessionToken) {
            latestProcessor = new LivenessCheckProcessor_1.LivenessCheckProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Initiate a 3D Liveness Check, then storing the 3D FaceMap in the Database, also known as "Enrollment".  A random enrollmentIdentifier is generated each time to guarantee uniqueness.
    function onEnrollUserPressed() {
        initializeResultObjects();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get a Session Token from the FaceTec SDK, then start the Enrollment.
        getSessionToken(function (sessionToken) {
            latestEnrollmentIdentifier = "skylifestyle_browser_app_" + SampleAppUtilities_1.SampleAppUtilities.generateUUId();
            latestProcessor = new EnrollmentProcessor_1.EnrollmentProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Perform 3D to 3D Authentication against the Enrollment previously performed.
    function onAuthenticateUserPressed(action) {
        var _a, _b;
        initializeResultObjects();
        var cookie = new universal_cookie_1.default();
        var userData = cookie.get("user_state");
        latestEnrollmentIdentifier = (_a = userData === null || userData === void 0 ? void 0 : userData.facetecDBRef) !== null && _a !== void 0 ? _a : "";
        //Reset action_authenticated
        var defaultFacetec = {
            authenticated: true,
            action_authenticated: _devMode !== null && _devMode !== void 0 ? _devMode : false,
        };
        var facetec = (_b = userData === null || userData === void 0 ? void 0 : userData.facetec) !== null && _b !== void 0 ? _b : defaultFacetec;
        facetec.action_authenticated = _devMode !== null && _devMode !== void 0 ? _devMode : false;
        if (userData === null || userData === void 0 ? void 0 : userData.uid) {
            cookie.set("user_state", __assign(__assign({}, userData), { facetec: facetec }), {
                sameSite: true,
            });
        }
        // For demonstration purposes, verify that we have an enrollmentIdentifier to Authenticate against.
        if (latestEnrollmentIdentifier.length === 0) {
            DeveloperStatusMessages_1.DeveloperStatusMessages.logAndDisplayMessage("Please enroll first before trying authentication.");
        }
        else {
            SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
            // Get a Session Token from the FaceTec SDK, then start the 3D to 3D Matching.
            getSessionToken(function (sessionToken) {
                latestProcessor = new AuthenticateProcessor_1.AuthenticateProcessor(sessionToken, exports.SampleApp);
            });
        }
    }
    // Perform a 3D Liveness Check, then an ID Scan, then Match the 3D FaceMap to the ID Scan.
    function onPhotoIDMatchPressed() {
        var _a;
        initializeResultObjects();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        var cookie = new universal_cookie_1.default();
        var userData = cookie.get("user_state");
        latestEnrollmentIdentifier = (_a = userData === null || userData === void 0 ? void 0 : userData.facetecDBRef) !== null && _a !== void 0 ? _a : "";
        // Get a Session Token from the FaceTec SDK, then start the 3D Liveness Check.  On Success, ID Scanning will start automatically.
        getSessionToken(function (sessionToken) {
            //latestEnrollmentIdentifier = "skylifestyle_browser_app_" + SampleAppUtilities.generateUUId();
            latestProcessor = new PhotoIDMatchProcessor_1.PhotoIDMatchProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Perform Photo ID Scan, generating a username each time to guarantee uniqueness.
    function onPhotoIDScanPressed() {
        initializeResultObjects();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get a Session Token from the FaceTec SDK, then start the 3D Liveness Check.  On Success, ID Scanning will start automatically.
        getSessionToken(function (sessionToken) {
            latestProcessor = new PhotoIDScanProcessor_1.PhotoIDScanProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Show the final result with the Session Review Screen.
    var onComplete;
    onComplete = function (sessionResult, idScanResult, latestNetworkResponseStatus) {
        latestSessionResult = sessionResult;
        latestIDScanResult = idScanResult;
        if (latestProcessor.isSuccess()) {
            // Display message to user, Success messages are already logged from the processors.
            DeveloperStatusMessages_1.DeveloperStatusMessages.displayMessage("See logs for details");
        }
        else {
            // Log result for unSuccess Sessions.
            DeveloperStatusMessages_1.DeveloperStatusMessages.logScanOncompleteResult(sessionResult, idScanResult);
            // Check for server offline
            if (isNetworkResponseServerIsOffline(latestNetworkResponseStatus) === true) {
                showAdditionalScreensServerIsDown();
                return;
            }
        }
        SampleAppUtilities_1.SampleAppUtilities.showMainUI();
    };
    // Check for server down status
    function isNetworkResponseServerIsOffline(networkResponseStatus) {
        return networkResponseStatus >= 500;
    }
    // Set a new customization for FaceTec Browser SDK.
    function onDesignShowcasePressed() {
        ThemeHelpers_1.ThemeHelpers.showNewTheme();
    }
    function onVocalGuidanceSettingsButtonPressed() {
        SampleAppUtilities_1.SampleAppUtilities.setVocalGuidanceMode();
    }
    // Display audit trail images captured from user's last FaceTec Browser SDK Session (if available).
    function onViewAuditTrailPressed() {
        SampleAppUtilities_1.SampleAppUtilities.showAuditTrailImages(latestSessionResult, latestIDScanResult);
    }
    var sessionTokenErrorHasBeenHandled = false;
    function onSessionTokenError(xhrStatus) {
        if (sessionTokenErrorHasBeenHandled === false) {
            sessionTokenErrorHasBeenHandled = true;
            if (xhrStatus !== undefined && isNetworkResponseServerIsOffline(xhrStatus)) {
                showAdditionalScreensServerIsDown();
            }
            else {
                onServerSessionTokenError();
            }
        }
    }
    // Get the Session Token from the server
    function getSessionToken(sessionTokenCallback) {
        sessionTokenErrorHasBeenHandled = false;
        //TODO - Add .content
        try {
            var XHR = new XMLHttpRequest();
            XHR.open("GET", Config_1.Config.BaseURL + "/session-token");
            XHR.setRequestHeader("X-Device-Key", Config_1.Config.DeviceKeyIdentifier);
            XHR.setRequestHeader("X-User-Agent", FaceTecSDK_1.FaceTecSDK.createFaceTecAPIUserAgentString(""));
            XHR.onreadystatechange = function () {
                if (this.readyState === XMLHttpRequest.DONE) {
                    var sessionToken = "";
                    try {
                        // Attempt to get the sessionToken from the response object.
                        sessionToken = JSON.parse(this.responseText).content.sessionToken;
                        // Something went wrong in parsing the response. Return an error.
                        if (typeof sessionToken !== "string") {
                            exports.SampleApp.onSessionTokenError(XHR.status);
                            return;
                        }
                    }
                    catch (_a) {
                        // Something went wrong in parsing the response. Return an error.
                        XHR.abort();
                        exports.SampleApp.onSessionTokenError(XHR.status);
                        return;
                    }
                    SampleAppUtilities_1.SampleAppUtilities.hideLoadingSessionToken();
                    sessionTokenCallback(sessionToken);
                }
            };
            // Wait 3s, if the request is not completed yet, show the session token loading screen
            window.setTimeout(function () {
                if (XHR.readyState !== XMLHttpRequest.DONE) {
                    if (sessionTokenErrorHasBeenHandled === false) {
                        SampleAppUtilities_1.SampleAppUtilities.showLoadingSessionToken();
                    }
                }
            }, 3000);
            XHR.onerror = function () {
                XHR.abort();
                exports.SampleApp.onSessionTokenError(XHR.status);
            };
            XHR.send();
        }
        catch (e) {
            exports.SampleApp.onSessionTokenError(undefined);
        }
    }
    function showAdditionalScreensServerIsDown() {
        AdditionalScreens_1.AdditionalScreens.showServerUpGradeView();
    }
    function onServerSessionTokenError() {
        SampleAppUtilities_1.SampleAppUtilities.handleErrorGettingServerSessionToken();
    }
    var getLatestEnrollmentIdentifier = function () {
        return latestEnrollmentIdentifier;
    };
    var clearLatestEnrollmentIdentifier = function () {
        latestEnrollmentIdentifier = "";
    };
    function exitAdditionalScreen() {
        AdditionalScreens_1.AdditionalScreens.exitAdditionalScreen(SampleAppUtilities_1.SampleAppUtilities.showMainUI);
    }
    return {
        onLivenessCheckPressed: onLivenessCheckPressed,
        onEnrollUserPressed: onEnrollUserPressed,
        onAuthenticateUserPressed: onAuthenticateUserPressed,
        onPhotoIDMatchPressed: onPhotoIDMatchPressed,
        onPhotoIDScanPressed: onPhotoIDScanPressed,
        onDesignShowcasePressed: onDesignShowcasePressed,
        onComplete: onComplete,
        getLatestEnrollmentIdentifier: getLatestEnrollmentIdentifier,
        clearLatestEnrollmentIdentifier: clearLatestEnrollmentIdentifier,
        onVocalGuidanceSettingsButtonPressed: onVocalGuidanceSettingsButtonPressed,
        onViewAuditTrailPressed: onViewAuditTrailPressed,
        onSessionTokenError: onSessionTokenError,
        latestSessionResult: latestSessionResult,
        latestIDScanResult: latestIDScanResult,
    };
})();
